/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiTransactionSummaryByAccount
 */
export interface ApiTransactionSummaryByAccount {
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionSummaryByAccount
     */
    account: string;
    /**
     * 
     * @type {string}
     * @memberof ApiTransactionSummaryByAccount
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ApiTransactionSummaryByAccount
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiTransactionSummaryByAccount
     */
    firstTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiTransactionSummaryByAccount
     */
    lastTime?: Date;
}

/**
 * Check if a given object implements the ApiTransactionSummaryByAccount interface.
 */
export function instanceOfApiTransactionSummaryByAccount(value: object): value is ApiTransactionSummaryByAccount {
    if (!('account' in value) || value['account'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function ApiTransactionSummaryByAccountFromJSON(json: any): ApiTransactionSummaryByAccount {
    return ApiTransactionSummaryByAccountFromJSONTyped(json, false);
}

export function ApiTransactionSummaryByAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiTransactionSummaryByAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'account': json['account'],
        'name': json['name'],
        'totalAmount': json['totalAmount'],
        'firstTime': json['firstTime'] == null ? undefined : (new Date(json['firstTime'])),
        'lastTime': json['lastTime'] == null ? undefined : (new Date(json['lastTime'])),
    };
}

export function ApiTransactionSummaryByAccountToJSON(json: any): ApiTransactionSummaryByAccount {
    return ApiTransactionSummaryByAccountToJSONTyped(json, false);
}

export function ApiTransactionSummaryByAccountToJSONTyped(value?: ApiTransactionSummaryByAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': value['account'],
        'name': value['name'],
        'totalAmount': value['totalAmount'],
        'firstTime': value['firstTime'] == null ? value['firstTime'] : value['firstTime'].toISOString(),
        'lastTime': value['lastTime'] == null ? value['lastTime'] : value['lastTime'].toISOString(),
    };
}

